// extracted by mini-css-extract-plugin
export default {"tabContent":"PriceBookDetail_tabContent__Frw1m","tabItem":"PriceBookDetail_tabItem__p1rQg"};